import { useEffect, useRef, useState } from 'react';

const BLINK_MS = 700;

/**
 * Tracks which table cells changed since the last snapshot.
 * @returns {Set<string>} keys like ``"523767:profit"``
 */
export function useCellBlink(rows, { rowKey = 'login', valueKeys = [] } = {}) {
  const prevRef = useRef(new Map());
  const [blinkCells, setBlinkCells] = useState(() => new Set());
  const keysSig = valueKeys.join(',');

  useEffect(() => {
    if (!rows?.length || !valueKeys.length) return undefined;

    const changed = new Set();
    const next = new Map();

    for (const row of rows) {
      const id = row[rowKey];
      if (id == null) continue;
      const prev = prevRef.current.get(id);
      const snap = {};
      for (const key of valueKeys) {
        snap[key] = row[key];
        const cellId = `${id}:${key}`;
        if (prev && prev[key] !== row[key]) {
          changed.add(cellId);
        }
      }
      next.set(id, snap);
    }

    prevRef.current = next;

    if (!changed.size) return undefined;

    setBlinkCells(changed);
    const timer = setTimeout(() => setBlinkCells(new Set()), BLINK_MS);
    return () => clearTimeout(timer);
  }, [rows, rowKey, keysSig, valueKeys]);

  return blinkCells;
}
